import React, { useEffect } from "react";
import { useGetDeletedUsers } from "../../hooks/useCrm";
import { AdvancedSearchItem } from "../AdvancedSearchItem/AdvancedSearchItem";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import Loading from "../Loadings/LoadingTable";
import Typography from "../Typography/Typography";
import { DeletedFilesStyle } from "./DeletedFilesStyle";

const DeletedFiles = () => {
  const { data, isLoading, hasNextPage, fetchNextPage } = useGetDeletedUsers();
  const length = data?.data?.sales_opportunities?.length;
  useEffect(() => {
    let fetching = false;
    const onScroll = async (event) => {
      const { scrollHeight, scrollTop, clientHeight } =
        event.target.scrollingElement;
      if (!fetching && scrollHeight - scrollTop <= clientHeight * 2.5) {
        fetching = true;

        if (hasNextPage) await fetchNextPage();

        fetching = false;
      }
    };
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [fetchNextPage, hasNextPage]);
  return isLoading ? (
    <Loading />
  ) : (
    <>
      <BreadCrumb
        margin="mt-3"
        num1="واحد CRM"
        num2="گزارشگیری"
        num3="پرونده های حذف شده"
        href1="/dashboard/crm"
        href2="/dashboard/crm/reporting"
      />
      <DeletedFilesStyle className="mt-3">
        <div className="header">
          <Typography size="14px">
            پرونده های حذف شده {length ? length : ""}
          </Typography>
        </div>
        <div className="content mt-2 row">
          <AdvancedSearchItem data={data} />
        </div>
      </DeletedFilesStyle>
    </>
  );
};

export default DeletedFiles;
